export interface SnippetPart {
  text: string
  mark: boolean
}

// ts_headline('russian', …) размечает совпадения тегами <b>…</b>. Парсим их сами
// (без dangerouslySetInnerHTML — распознаём только этот тег; остальной текст
// рендерится React'ом как есть → XSS-safe даже на пользовательском контенте).
export function parseHighlight(text: string): SnippetPart[] {
  const parts: SnippetPart[] = []
  const re = /<b>(.*?)<\/b>/gs
  let last = 0
  for (let m = re.exec(text); m !== null; m = re.exec(text)) {
    if (m.index > last) parts.push({ text: text.slice(last, m.index), mark: false })
    parts.push({ text: m[1] ?? '', mark: true })
    last = m.index + m[0].length
  }
  if (last < text.length) parts.push({ text: text.slice(last), mark: false })
  return parts
}
